/** @license @dairyfarm/eval-web v3.0.0
* Copyright 2020 Texas A&M Center for Applied Technology, 
* Texas A&M Engineering Experiment Station, The Texas A&M 
* University System.
* 
* This source code/schema and any derivative work is Texas 
* A&M Engineering Experiment Station intellectual property 
* and protected by copyright law. Usage is restricted solely 
* to the FARM Animal Care and Environmental Stewardship 
* programs administered by the National Milk Producers 
* Federation. Dissemination of this source code and/or 
* derivative work creation is strictly prohibited without 
* express written permission from the Texas A&M Engineering 
* Experiment Station.
*/
import { DBSchema, OpenDBCallbacks } from "idb";
import { DairyFARMDB } from "../store";

export const COOPS_STORE = "coops" as "coops";

export interface Coop {
  id: string;
  name: string;
  is_environmental_participant?: boolean;
  is_wfd_participant?: boolean;
  farms?: string[];  // should this be optional?
  address?: string; // should this be optional
  city?: string; // should this be optional?
  state?: string; // should this be optional
  zip?: string; // should this be optional?
  capture_eval_photos?: boolean;
  is_third_party_coop?: boolean;
}

/**
 * @deprecated Coops will be stored using redux-persist. This table should remain empty
 */
export interface CoopsStore extends DBSchema {
  [COOPS_STORE]: {
    key: string;
    value: Coop;
  };
}

export const coopStoreConfig: OpenDBCallbacks<DairyFARMDB> = {
  upgrade(db, oldVersion, newVersion, transaction) {
    if (!db.objectStoreNames.contains(COOPS_STORE)) {
      db.createObjectStore(COOPS_STORE, {
        keyPath: "id",
      });
    }
  },
};
